import type { StateSlug } from 'Types/enquiryStates';
import type { VehicleListItem } from 'Types/vehicle';
import { availableStates } from 'Utilities/vehicleState';

import useFetchSelectedVehicle from '../useFetchSelectedVehicle/useFetchSelectedVehicle';

const useSelectedVehicle = (vehicleId?: VehicleListItem['id']): VehicleListItem | undefined => {
	const { data: selectedVehicle, isError } = useFetchSelectedVehicle(vehicleId);
	if (!vehicleId && isError) {
		return undefined;
	}
	const hasCorrectStateSlug = (availableStates as (StateSlug | undefined)[]).includes(
		selectedVehicle?.[0]?.state?.slug,
	);
	return hasCorrectStateSlug ? selectedVehicle?.[0] : undefined;
};

export default useSelectedVehicle;
